import React, { useState } from "react";
import axios from "axios";
import "./scorecardContact.css";
import "../../index.css";
import "./ScorecardHome/scorecardHome.css";
import Button from "../../components/button/button";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import PolicyContainer from "../../components/policy/policyContainer";
import PopUpSuccessMessageModal from "../../popUpForms/formSubmissionSuccessMessageModal/popUpSuccessMessageModal";
import { baseURL } from "../../baseURL";

const ScorecardContact = () => {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [submissionError, setSubmissionError] = useState(false);
  const [successForm, setSuccessForm] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    organization: "",
    role: "",
    zip: "",
    message: "",
    updates: false,
    meetings: false,
    sponsor: false,
    partner: false,
    showcase: false,
    demo: false,
    collaborate: false,
    funding: false,
    pilot: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitScorecardContactForm = async (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      scorecardForm: true,
    };

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-contact-form`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setSubmissionSuccess(true);
        setSuccessForm("scorecard-contact");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          organization: "",
          role: "",
          zip: "",
          message: "",
          updates: false,
          meetings: false,
          sponsor: false,
          partner: false,
          showcase: false,
          demo: false,
          collaborate: false,
          funding: false,
          pilot: false,
        });
      }
    } catch (error) {
      setSubmissionSuccess(true);
      setSuccessForm("error");
      console.error("Error submitting form:", error.response || error.message);
    }
  };

  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-contact">
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmitScorecardContactForm}>
          <p>
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>

          <div className="form-group">
            <label>First Name*</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name*</label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Organization</label>
            <input
              name="organization"
              value={formData.organization}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Role</label>
            <input name="role" value={formData.role} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Zip/Postal Code*</label>
            <input
              name="zip"
              value={formData.zip}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <fieldset>Select all that apply:</fieldset>
            <fieldset>
              <legend>Subscribe</legend>
              <label>
                <input
                  type="checkbox"
                  name="updates"
                  checked={formData.updates}
                  onChange={handleChange}
                />
                Receive exclusive updates on events, news, and access to weekly
                Consortium meetings
              </label>
            </fieldset>
            <fieldset>
              <legend>Sign up</legend>
              <label>
                <input
                  type="checkbox"
                  name="meetings"
                  checked={formData.meetings}
                  onChange={handleChange}
                />
                Attend weekly Consortium meetings
              </label>
            </fieldset>
            <fieldset>
              <legend>Explore</legend>
              <label>
                <input
                  type="checkbox"
                  name="sponsor"
                  checked={formData.sponsor}
                  onChange={handleChange}
                />
                Sponsor Programs
              </label>
              <label>
                <input
                  type="checkbox"
                  name="partner"
                  checked={formData.partner}
                  onChange={handleChange}
                />
                Partner Program
              </label>
            </fieldset>
            <fieldset>
              <legend>Apply to</legend>
              <label>
                <input
                  type="checkbox"
                  name="showcase"
                  checked={formData.showcase}
                  onChange={handleChange}
                />
                Present in Wildfire Innovation Showcase
              </label>
              <label>
                <input
                  type="checkbox"
                  name="demo"
                  checked={formData.demo}
                  onChange={handleChange}
                />
                Demo my product and/or company
              </label>
            </fieldset>
            <fieldset>
              <legend>Get Involved</legend>
              <label>
                <input
                  type="checkbox"
                  name="collaborate"
                  checked={formData.collaborate}
                  onChange={handleChange}
                />
                Collaborate on opportunities
              </label>
              <label>
                <input
                  type="checkbox"
                  name="funding"
                  checked={formData.funding}
                  onChange={handleChange}
                />
                Co-apply to grant or funding opportunities
              </label>
              <label>
                <input
                  type="checkbox"
                  name="pilot"
                  checked={formData.pilot}
                  onChange={handleChange}
                />
                Pilot the Community Wildfire Resilience Scorecard
              </label>
            </fieldset>
          </div>
          <PolicyContainer text="Contact Us" />
          <div className="form-group">
            <Button
              text="Contact Us"
              color="var(--green)"
              className="card-btn"
            />
          </div>
        </form>
      </div>

      <PopUpSuccessMessageModal
        successForm={successForm}
        showSuccessFormMessage={submissionSuccess}
        setShowSuccessFormMessage={setSubmissionSuccess}
      />
    </>
  );
};

export default ScorecardContact;
